

export function getUnixDateFromDate(date: Date) : number {
    return parseInt((date.getTime()/1000).toFixed(0), 10);
}
